import React, { useMemo } from 'react';

import classnames from 'classnames';

import { useCurrency } from '@ezbobdev/ui-commons';

const MaterialCurrency = (props) => {
  const { className } = props;
  const { formattedValue } = useCurrency(props, MaterialCurrency.displayName);

  return useMemo(() => {
    return <span className={classnames(MaterialCurrency.displayName, className)}>{formattedValue}</span>;
  }, [formattedValue, className]);
};

MaterialCurrency.displayName = 'MaterialCurrency';

export default MaterialCurrency;
